<template>
  <div class="container v-content-container tooltip-wrapper popup-wrapper">
    <div class="row">
      <div class="col-xs-12">
        <h1>
          <i class="fa fa-user fa-fw fa-id-card-o"></i>&nbsp;
          <span v-if="selectedInstructorId != null">
            {{ noDataExist ? "Instructor" : originalName }}
          </span>
          <span v-else-if="!loading">
            {{ $label("event.new_instructor", "New instructor") }}
          </span>
        </h1>
      </div>
    </div>

    <navigation-tabs></navigation-tabs>

    <div class="row">
      <div class="col-xs-12">&nbsp;</div>
    </div>

    <error404 v-if="noDataExist" />

    <template v-else>
      <div v-show="loading" class="row">
        <div class="col-xs-12">
          <view-loader
            margin-top-pixels="15"
            border-color="primary"
          ></view-loader>
        </div>
      </div>

      <!-- modal dialog to upload/crop/change an image -->
      <div
        class="modal fade"
        id="instructorImgModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="instructorImgModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog">
          <div class="modal-content tooltip-wrapper">
            <div id="update-img-form">
              <input
                type="hidden"
                name="controlData"
                id="controlData"
                value=""
              />
              <div class="modal-header">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-hidden="true"
                >
                  &times;
                </button>
                <h3 class="modal-title" id="instructorImgModalLabel">
                  <i class="text-primary fa fa-fw fa-lg fa-scissors"></i>
                  {{ $label("common.edit_image", "Edit image") }}
                </h3>
              </div>

              <div class="modal-body text-center">
                <div id="cropper-img">
                  <img id="instructorImgImage" :src="newUrl" />
                </div>
                <div class="">
                  <span
                    class="btn btn-primary btn-lg btn-file"
                    v-tooltip="{
                      content: $label(
                        'common.upload_new_image',
                        'Upload new image'
                      ),
                      classes: 'custom-tooltip'
                    }"
                  >
                    <i class="fa fa-lg fa-fw fa-upload"></i>
                    <input
                      id="cropper-upload"
                      name="file"
                      type="file"
                      ref="profileImage"
                      accept="image/*"
                      @change="onFileChange"
                    />
                  </span>
                  <button
                    id="cropper-zoom-in"
                    class="btn btn-primary"
                    v-tooltip="{
                      content: $label('common.enlarge_image', 'Enlarge image'),
                      classes: 'custom-tooltip'
                    }"
                  >
                    <i class="fa fa-lg fa-fw fa-plus-circle"></i>
                  </button>
                  <button
                    id="cropper-zoom-out"
                    class="btn btn-primary"
                    v-tooltip="{
                      content: $label('common.reduce_image', 'Reduce image'),
                      classes: 'custom-tooltip'
                    }"
                  >
                    <i class="fa fa-lg fa-fw fa-minus-circle"></i>
                  </button>
                </div>
              </div>

              <div class="modal-footer">
                <button
                  class="btn btn-default"
                  data-dismiss="modal"
                  aria-hidden="true"
                  @click="newUrl = url"
                >
                  {{ $label("common.cancel", "Cancel") }}
                </button>
                <button
                  class="btn btn-primary"
                  :class="{
                    disabled: placeHolderUrl == newUrl || newUrl == null
                  }"
                  data-dismiss="modal"
                  aria-hidden="true"
                  @click="onUpdateInstructorProfileImage"
                >
                  {{ $label("common.ok", "OK") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-show="!loading" class="tab-content">
        <div id="instructor-form" action="" method="post">
          <div class="tab-pane active">
            <div class="row">
              <div class="col-sm-6 tooltip-wrapper">
                <h2>
                  <i class="fa fa-fw fa-lg fa-user"></i>
                  {{ $label("common.name", "Name") }}
                </h2>
                <p></p>
                <div class="v-form-partial">
                  <div class="v-form">
                    <fieldset>
                      <div class="row">
                        <section class="col col-4">
                          <label class="label">{{
                            $label(
                              "event.instructor_profile_image",
                              "Profile image"
                            )
                          }}</label>
                          <label class="input">
                            <div
                              id="img_preview"
                              style="cursor: pointer;"
                              data-toggle="modal"
                              data-target="#instructorImgModal"
                            >
                              <img
                                :src="url"
                                class="img-responsive img-thumbnail col-12 col"
                              />
                            </div>
                          </label>
                        </section>
                        <section class="col col-2 mt-6">
                          <label class="label">&nbsp;</label>
                          <button
                            id="edit-instructor-profile-image"
                            class="btn btn-primary v-form-btn v-white v-profile-img-button"
                            :class="{
                              'is-disabled':
                                !readWriteAccess || !instructorImageRemovable
                            }"
                            v-tooltip="{
                              content: $label(
                                'common.edit_image',
                                'Edit image'
                              ),
                              classes: 'custom-tooltip'
                            }"
                            data-toggle="modal"
                            data-target="#instructorImgModal"
                          >
                            <i class="fa fa-lg fa-fw fa-pencil"></i>
                          </button>
                          <button
                            id="delete-instructor-profile-image"
                            class="btn btn-primary v-form-btn v-white v-profile-img-button"
                            :class="{
                              'is-disabled':
                                !readWriteAccess ||
                                !instructorImageRemovable ||
                                selectedInstructorId == null ||
                                url == placeHolderUrl
                            }"
                            v-tooltip="{
                              content: $label(
                                'common.delete_image',
                                'Delete image'
                              ),
                              classes: 'custom-tooltip'
                            }"
                            @click="onDeleteInstructorProfileImage"
                          >
                            <i class="fa fa-lg fa-fw fa-trash-o"></i>
                          </button>
                          <button
                            id="upload-instructor-profile-image"
                            class="btn btn-primary v-form-btn v-white v-profile-img-button "
                            :class="{ 'is-disabled': !readWriteAccess }"
                            data-btn="upload"
                            v-tooltip="{
                              content: $label('common.new_image', 'New image'),
                              classes: 'custom-tooltip'
                            }"
                            data-toggle="modal"
                            data-target="#instructorImgModal"
                          >
                            <i class="fa fa-lg fa-fw fa-upload"></i>
                          </button>
                        </section>

                        <!-- BEGIN Gender -->
                        <section class="col col-3">
                          <label class="label">{{
                            $label("common.gender", "Gender")
                          }}</label>
                          <label class="select">
                            <select
                              v-model="selectedInstructor.gender"
                              :disabled="updating"
                            >
                              <option value="0">{{
                                $label("common.gender", "Gender")
                              }}</option>
                              <option value="2">{{
                                $label("common.gender_male", "Male")
                              }}</option>
                              <option value="1">{{
                                $label("common.gender_female", "Female")
                              }}</option>
                            </select>
                            <i></i>
                          </label>
                        </section>
                        <!-- End Gender -->

                        <!-- BEGIN Title -->
                        <section class="col col-6">
                          <text-input
                            v-model="selectedInstructor.title"
                            id="instructor-title"
                            :label="$label('common.title', 'Title')"
                            :placeholder="$label('common.title', 'Title')"
                            :has-error="hasError('title')"
                            :error="getError('title')"
                            :is-disabled="updating"
                            @keyup.native.enter="createOrUpdateInstructor"
                          />
                        </section>
                        <!-- END Title -->
                      </div>

                      <!-- BEGIN Name -->
                      <section>
                        <text-input
                          v-model="selectedInstructor.name"
                          id="instructor-name"
                          :label="$label('common.name', 'Name')"
                          :placeholder="$label('common.name', 'Name')"
                          :has-error="hasError('name')"
                          :error="getError('name')"
                          :is-disabled="updating"
                          @keyup.native.enter="createOrUpdateInstructor"
                        />
                      </section>
                      <!-- END Name -->

                      <div class="row">
                        <!-- BEGIN Email -->
                        <section class="col col-8">
                          <label class="label">{{
                            $label(
                              "common.email_address_long",
                              "E-Mail address"
                            )
                          }}</label>
                          <label class="input">
                            <i class="icon-append icon-envelope"></i>
                            <input
                              v-model="selectedInstructor.email"
                              :class="{ 'text-input-error': hasError('email') }"
                              :placeholder="
                                $label('common.email_address_short')
                              "
                              :disabled="updating"
                              id="instructor-email"
                              type="email"
                            />
                          </label>

                          <p v-if="hasError('email')" class="text-danger">
                            {{ getError("email") }}
                          </p>
                        </section>
                        <!-- END Email -->

                        <!-- BEGIN Display email -->
                        <section class="col col-4 mt-8">
                          <label class="label">&nbsp;</label>
                          <label class="checkbox">
                            <input
                              v-model="selectedInstructor.display_email"
                              id="instructor-display-email"
                              type="checkbox"
                              value="true"
                            /><i></i>
                            {{
                              $label(
                                "event.instructor_display_in_profile",
                                "Display in profile"
                              )
                            }}
                          </label>
                        </section>
                        <!-- END Display email -->
                      </div>

                      <div class="row">
                        <!-- BEGIN Phone country code -->
                        <section class="col col-3">
                          <label class="label">{{
                            $label("common.prefix", "Prefix")
                          }}</label>
                          <label class="input">
                            <input
                              v-model="selectedInstructor.phone_number.prefix"
                              :class="{
                                'text-input-error': hasError(
                                  'phone_number.prefix'
                                )
                              }"
                              type="text"
                              placeholder="XX"
                              :disabled="updating"
                              id="instructor-phone-prefix"
                            />
                          </label>

                          <p
                            v-if="hasError('phone_number.prefix')"
                            class="text-danger"
                          >
                            {{ getError("phone_number.prefix") }}
                          </p>
                        </section>
                        <!-- END Phone country code -->

                        <!-- BEGIN Phone number -->
                        <section class="col col-5">
                          <label class="label">{{
                            $label("common.phone_number", "Phone number")
                          }}</label>
                          <label class="input">
                            <i class="icon-append fa fa-phone"></i>
                            <input
                              v-model="selectedInstructor.phone_number.number"
                              :class="{
                                'text-input-error': hasError(
                                  'phone_number.number'
                                )
                              }"
                              :placeholder="
                                $label(
                                  'common.phone_number_placeholder',
                                  'XXXXXXXX'
                                )
                              "
                              :disabled="updating"
                              id="instructor-phone-number"
                              type="tel"
                            />
                          </label>

                          <p
                            v-if="hasError('phone_number.number')"
                            class="text-danger"
                          >
                            {{ getError("phone_number.number") }}
                          </p>
                        </section>
                        <!-- END Phone number -->

                        <!-- BEGIN Display phone number -->
                        <section class="col col-4 mt-8">
                          <label class="label">&nbsp;</label>
                          <label class="checkbox">
                            <input
                              v-model="selectedInstructor.display_phone_number"
                              id="instructor-display-phone-number"
                              type="checkbox"
                              value="true"
                            /><i></i>
                            {{
                              $label(
                                "event.instructor_display_in_profile",
                                "Display in profile"
                              )
                            }}
                          </label>
                        </section>
                        <!-- END Display phone number -->
                      </div>

                      <!-- BEGIN Internal note -->
                      <section>
                        <label class="label">{{
                          $label("instructor.note", "Note")
                        }}</label>
                        <label class="textarea">
                          <textarea
                            v-model="selectedInstructor.note"
                            :class="{ 'text-input-error': hasError('note') }"
                            :placeholder="$label('instructor.note', 'Note')"
                            :disabled="updating"
                            id="instructor-note"
                            rows="3"
                          >
                          </textarea>
                        </label>
                      </section>
                      <!-- END Internal note -->
                    </fieldset>
                  </div>
                </div>
              </div>

              <div class="col-sm-6 tooltip-wrapper">
                <h2>
                  <i class="fa fa-fw fa-lg fa-user-circle-o"></i>
                  {{
                    $label("event.instructor_online_profiel", "Online profile")
                  }}
                </h2>
                <p></p>
                <div class="v-form-partial">
                  <div class="v-form">
                    <fieldset>
                      <div class="row">
                        <section class="col col-12">
                          <label class="label"
                            >{{ $label("common.description", "Description") }}
                            <i
                              v-tooltip.top-center="
                                '<div class=&quot;tooltip-title-background&quot;><p class=&quot;tooltip-title&quot;><b>' +
                                  $label(
                                    'event.profile_description',
                                    'Profile description'
                                  ) +
                                  '</b></p></div>' +
                                  '<p class=&quot;tooltip-content&quot;>' +
                                  $label(
                                    'event.instructor_online_profile_description_tooltip',
                                    'This text will be displayed online and should contain useful information.'
                                  ) +
                                  '</p>'
                              "
                              class="text-primary fa fa-lg fa-info-circle pull-right"
                            ></i
                          ></label>

                          <quill-editor
                            v-model="selectedInstructor.description"
                            ref="instructorDescriptionEditor"
                            :options="editorOptions"
                          >
                          </quill-editor>
                        </section>
                      </div>

                      <div class="row">
                        <section class="col col-12">
                          <label class="input">
                            <i
                              class="icon-append fa fa-fw fa-lg fa-facebook-official"
                            ></i>
                            <input
                              v-model="selectedInstructor.facebook_link"
                              :class="{
                                'text-input-error': hasError('facebook_link')
                              }"
                              :placeholder="
                                $label('common.facebook', 'Facebook')
                              "
                              :disabled="updating"
                              id="instructor-facebook-link"
                              type="text"
                            />
                          </label>

                          <p
                            v-if="hasError('facebook_link')"
                            class="text-danger"
                          >
                            {{ getError("facebook_link") }}
                          </p>
                        </section>
                      </div>
                      <div class="row">
                        <section class="col col-12">
                          <label class="input">
                            <i
                              class="icon-append fa fa-fw fa-lg fa-twitter"
                            ></i>
                            <input
                              v-model="selectedInstructor.twitter_link"
                              :class="{
                                'text-input-error': hasError('twitter_link')
                              }"
                              :placeholder="$label('common.twitter', 'Twitter')"
                              :disabled="updating"
                              id="instructor-twitter-link"
                              type="text"
                            />
                          </label>

                          <p
                            v-if="hasError('twitter_link')"
                            class="text-danger"
                          >
                            {{ getError("twitter_link") }}
                          </p>
                        </section>
                      </div>
                      <div class="row">
                        <section class="col col-12">
                          <label class="input">
                            <i
                              class="icon-append fa fa-fw fa-lg fa-youtube"
                            ></i>
                            <input
                              v-model="selectedInstructor.youtube_link"
                              :class="{
                                'text-input-error': hasError('youtube_link')
                              }"
                              :placeholder="$label('common.youtube', 'Youtube')"
                              :disabled="updating"
                              id="instructor-youtube-link"
                              type="text"
                            />
                          </label>

                          <p
                            v-if="hasError('youtube_link')"
                            class="text-danger"
                          >
                            {{ getError("youtube_link") }}
                          </p>
                        </section>
                      </div>
                      <div class="row">
                        <section class="col col-12">
                          <label class="input">
                            <i
                              class="icon-append fa fa-fw fa-lg fa-globe col col-2 text-right"
                            ></i>
                            <input
                              v-model="selectedInstructor.website"
                              :class="{
                                'text-input-error': hasError('website')
                              }"
                              :placeholder="$label('common.website', 'Website')"
                              :disabled="updating"
                              id="instructor-website"
                              type="text"
                            />
                          </label>

                          <p v-if="hasError('website')" class="text-danger">
                            {{ getError("website") }}
                          </p>
                        </section>
                      </div>
                    </fieldset>
                  </div>
                </div>
              </div>
            </div>

            <div v-show="readWriteAccess" class="row">
              <div class="col-sm-6 tooltip-wrapper">
                <h2>
                  <i class="fa fa-fw fa-lg fa-list-alt"></i>
                  {{
                    $label(
                      "event.course_participations",
                      "Participations in courses"
                    )
                  }}
                </h2>
                <p></p>
                <div class="v-form-partial">
                  <div class="v-form">
                    <fieldset>
                      <div class="row">
                        <section class="col col-12">
                          <div class="v-datatable table-responsive">
                            <div>
                              <table
                                class="table table-bordered table-responsive table-hover dataTable"
                              >
                                <thead>
                                  <tr>
                                    <th class="text-center">
                                      {{ $label("common.period", "Period") }}
                                    </th>
                                    <th class="text-center">
                                      {{
                                        $label(
                                          "common.number_of_courses_short",
                                          "# Courses"
                                        )
                                      }}
                                    </th>
                                    <th class="text-center">
                                      {{
                                        $label(
                                          "common.number_of_appointments_short",
                                          "# Appointments"
                                        )
                                      }}
                                    </th>
                                    <th class="text-center">
                                      {{ $label("common.hours", "Hours") }}
                                    </th>
                                    <th class="text-center">
                                      {{ $label("common.actions", "Actions") }}
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr class="v-bg-gray">
                                    <td class="v-table">2021</td>
                                    <td class="text-right v-table">2</td>
                                    <td class="text-right v-table">5</td>
                                    <td class="text-right v-table">320</td>
                                    <td class="text-center v-table">
                                      <div class="btn-group">
                                        <a
                                          target="_blank"
                                          href="/settings/courses/coach/$this->coachId/csv/$year/"
                                          id="$year"
                                          class="csvexport btn btn-sm v-form-btn btn-default v-inline-table-btn-group"
                                          v-tooltip="{
                                            content: $label(
                                              'common.csv_export',
                                              'CSV export'
                                            ),
                                            classes: 'custom-tooltip'
                                          }"
                                          ><i
                                            class="fa fa-fw fa-lg fa-download text-primary"
                                          ></i
                                          >{{ $label("common.csv", "CSV") }}</a
                                        >
                                        <button
                                          id="expand_$year"
                                          class="expandBtn v-form-btn btn btn-sm btn-primary v-inline-table-btn-group"
                                          v-tooltip="{
                                            content: $label(
                                              'common.more_details',
                                              'More details'
                                            ),
                                            classes: 'custom-tooltip'
                                          }"
                                        >
                                          <i
                                            class="fa fa-fw fa-lg fa-expand"
                                          ></i>
                                        </button>
                                        <button
                                          id="collapse_$year"
                                          class="collapseBtn v-form-btn btn btn-sm btn-primary hide v-inline-table-btn-group"
                                          v-tooltip="{
                                            content: $label(
                                              'common.less_details',
                                              'Less details'
                                            ),
                                            classes: 'custom-tooltip'
                                          }"
                                        >
                                          <i
                                            class="fa fa-fw fa-lg fa-compress"
                                          ></i>
                                        </button>
                                      </div>
                                    </td>
                                  </tr>
                                  <tr class="details_<?= $year ?> hide">
                                    <td class="v-table">
                                      \helper\Registry::get()->monthNames[$detailRecord['month']]
                                    </td>
                                    <td class="text-right v-table">
                                      (array_key_exists('course_ids',
                                      $detailRecord) ?
                                      count($detailRecord['course_ids']) : 0)
                                    </td>
                                    <td class="text-right v-table">
                                      (array_key_exists('numAppointments',
                                      $detailRecord) ?
                                      $detailRecord['numAppointments'] : 0)
                                    </td>
                                    <td class="text-right v-table">
                                      number_format((array_key_exists('minutes',
                                      $detailRecord) ?
                                      round($detailRecord['minutes'] / 60, 1) :
                                      0), 1, ',', '')
                                    </td>
                                    <td class="text-center v-table">
                                      number_format($record['totalPrice'] *
                                      round($detailRecord['minutes'] / 60, 1),
                                      2, '.','' )
                                      $this->localizer->getCurrencySign()
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </section>
                      </div>
                    </fieldset>
                  </div>
                </div>
                <p></p>
                <div class="v-form-partial">
                  <h2>{{ $label("common.hourly_rate", "Hourly rate") }}</h2>
                  <p></p>
                  <div class="v-form-partial">
                    <div class="v-form">
                      <fieldset>
                        <div class="row">
                          <section class="col col-4">
                            <label class="label">{{
                              $label("common.input", "Input")
                            }}</label>
                            <label class="select">
                              <select :disabled="updating">
                                <option value="0">{{
                                  $label("common.net", "Net")
                                }}</option>
                                <option value="1">{{
                                  $label("common.gross", "Gross")
                                }}</option>
                              </select>
                              <i></i>
                            </label>
                          </section>
                          <section class="col col-3">
                            <label class="label">{{
                              $label("common.vat", "VAT")
                            }}</label>
                            <label class="select">
                              <select id="instructor-vat">
                                <option value="0">{{
                                  $label("common.none", "None")
                                }}</option>
                                <option value="5">5 %</option>
                                <option value="10">10 %</option>
                                <option value="15">15 %</option>
                                <option value="20">20 %</option>
                              </select>
                              <i></i>
                            </label>
                          </section>
                          <!-- BEGIN Price per hour -->
                          <section class="col col-3">
                            <text-input
                              id="instructor-price-per-hour"
                              :label="
                                $label(
                                  'common.price_per_hour',
                                  'Price per hour'
                                )
                              "
                              :placeholder="
                                $label(
                                  'common.price_per_hour',
                                  'Price per hour'
                                )
                              "
                              :has-error="hasError('price_per_hour')"
                              :error="getError('price_per_hour')"
                              :is-disabled="updating"
                              @keyup.native.enter="createOrUpdateInstructor"
                            />
                          </section>
                          <!-- END Price per hour -->
                        </div>
                      </fieldset>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-6 tooltip-wrapper">
                <h2>
                  <i class="fa fa-fw fa-lg fa-cog"></i>
                  {{
                    $label("event.additional_settings", "Additional settings")
                  }}
                </h2>
                <p></p>
                <div class="v-form-partial">
                  <div class="v-form">
                    <fieldset>
                      <div class="row">
                        <section class="col col-12">
                          <label class="label"
                            >{{
                              $label(
                                "event.instructor_access",
                                "Instructor access"
                              )
                            }}
                            <i
                              v-tooltip.top-center="
                                '<div class=&quot;tooltip-title-background&quot;><p class=&quot;tooltip-title&quot;><b>' +
                                  $label(
                                    'event.instructor_access',
                                    'Instructor access'
                                  ) +
                                  '</b></p></div>' +
                                  '<p class=&quot;tooltip-content&quot;>' +
                                  $label(
                                    'event.instructor_access_tooltip',
                                    'Here you can create an own access to the manager for the instructor. With this access the instructor can manage his or her own courses.'
                                  ) +
                                  '</p>'
                              "
                              class="text-primary fa fa-lg fa-info-circle pull-right"
                            ></i
                          ></label>
                        </section>
                      </div>
                      <div class="row">
                        <section class="col col-6 text-center">
                          <a
                            v-show="hasAccount"
                            class="btn v-form-btn v-white btn-primary"
                            :class="{
                              'is-disabled':
                                userMgmtAccess && selectedInstructorId != null
                            }"
                            href="/settings/staff/associate/'$this->coachId/"
                          >
                            <i class="fa fa-lg fa-fw fa-user"></i>
                            {{ $label("event.show_access", "Show access") }}
                          </a>
                          <a
                            v-show="!hasAccount"
                            class="btn v-form-btn v-white btn-primary is-disabled"
                          >
                            <i class="fa fa-lg fa-fw fa-user"></i>
                            {{ $label("event.show_access", "Show access") }}
                          </a>
                        </section>
                        <section class="col col-6 text-center">
                          <a
                            v-show="hasAccount"
                            class="btn v-form-btn v-white btn-danger"
                            :class="{
                              'is-disabled':
                                userMgmtAccess && selectedInstructorId != null
                            }"
                            href="/settings/staff/associate/$this->coachId/delete/"
                          >
                            <i class="fa fa-lg fa-fw fa-trash-o"></i>
                            {{ $label("event.delete_access", "Delete access") }}
                          </a>
                          <a
                            v-show="!hasAccount"
                            class="btn v-form-btn v-white btn-primary"
                            :class="{
                              'is-disabled':
                                userMgmtAccess && selectedInstructorId != null
                            }"
                            href="/settings/staff/associate/$this->coachId/"
                          >
                            <i class="fa fa-lg fa-fw fa-user-plus"></i>
                            {{ $label("event.create_access", "Create access") }}
                          </a>
                        </section>
                      </div>

                      <div class="row">
                        <section class="col col-12">
                          <label class="label"
                            >{{
                              $label(
                                "event.billing_by_instructor",
                                "Billing by instructor"
                              )
                            }}
                            <i
                              v-tooltip.top-center="
                                '<div class=&quot;tooltip-title-background&quot;><p class=&quot;tooltip-title&quot;><b>' +
                                  $label(
                                    'event.instructor_own_billing',
                                    'Own billing for instructor'
                                  ) +
                                  '</b></p></div>' +
                                  '<p class=&quot;tooltip-content&quot;>' +
                                  $label(
                                    'event.instructor_own_billing_tooltip',
                                    'If activated, courses can be billed directly via the instructor. For this purpose own billing options are defined:'
                                  ) +
                                  '</p>' +
                                  '<ul class=&quot;tooltip-content&quot; style=&quot;padding-left: 20px; list-style-type: circle;&quot;>' +
                                  '<li>' +
                                  $label('common.logo', 'Logo') +
                                  '</li>' +
                                  '<li>' +
                                  $label(
                                    'common.invoice_address',
                                    'Invoice address'
                                  ) +
                                  '</li>' +
                                  '<li>' +
                                  $label(
                                    'common.bank_details',
                                    'Bank details'
                                  ) +
                                  '</li>' +
                                  '</ul>'
                              "
                              class="text-primary fa fa-lg fa-info-circle pull-right"
                            ></i
                          ></label>
                        </section>
                      </div>
                      <div class="row">
                        <section class="col col-6 text-center">
                          <a
                            v-show="hasOperator"
                            class="btn v-form-btn v-white btn-primary"
                            :class="{
                              'is-disabled':
                                readWriteAccess && selectedInstructorId != null
                            }"
                            href="/settings/operator/$this->operatorPurpose/data/"
                          >
                            <i class="fa fa-lg fa-fw fa-user"></i>
                            {{
                              $label("event.invoice_details", "Invoice details")
                            }}
                          </a>
                          <a
                            v-show="hasOperator"
                            class="btn v-form-btn v-white btn-primary is-disabled"
                          >
                            <i class="fa fa-lg fa-fw fa-file-text-o"></i>
                            {{
                              $label("event.invoice_details", "Invoice details")
                            }}
                          </a>
                        </section>
                        <section class="col col-6 text-center">
                          <a
                            v-show="hasOperator"
                            class="btn v-form-btn v-white btn-danger"
                            :class="{
                              'is-disabled':
                                readWriteAccess && selectedInstructorId != null
                            }"
                            href="/settings/operator/associate/$this->coachId/delete/"
                          >
                            <i class="fa fa-lg fa-fw fa-trash-o"></i>
                            {{
                              $label(
                                "event.deactivate_billing",
                                "Deactivate billing"
                              )
                            }}
                          </a>
                          <a
                            v-show="!hasOperator"
                            class="btn v-form-btn v-white btn-primary"
                            :class="{
                              'is-disabled':
                                readWriteAccess && selectedInstructorId != null
                            }"
                            href="/settings/operator/associate/$this->coachId/new/"
                          >
                            <i class="fa fa-lg fa-fw fa-file-text-o"></i>
                            {{
                              $label(
                                "event.deactivate_billing",
                                "Deactivate billing"
                              )
                            }}
                          </a>
                        </section>
                      </div>
                      <div
                        v-show="instructorHideCustomersMenuInput !== 'disabled'"
                        class="row"
                      >
                        <section class="col col-6">
                          <label class="label">&nbsp;</label>
                          <label
                            class="checkbox"
                            :class="{
                              'is-disabled':
                                instructorHideCustomersMenuInput === 'readonly'
                            }"
                          >
                            <input
                              type="checkbox"
                              value="true"
                              name="hide_customers_menu"
                              :checked="instructorHideCustomersMenu"
                              :class="{
                                disabled:
                                  instructorHideCustomersMenuInput ===
                                  'readonly'
                              }"
                            /><i></i>
                            {{
                              $label(
                                "event.block_access_to_invoices",
                                "Block access to invoices"
                              )
                            }}
                          </label>
                        </section>
                      </div>
                    </fieldset>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-6 tooltip-wrapper">
                <h2>
                  <i class="fa fa-fw fa-lg"></i>
                  {{ $label("event.event_categories", "Event categories") }}
                </h2>
                <p></p>
                <div class="v-form-partial">
                  <div class="v-form">
                    <fieldset>
                      <!-- BEGIN Categories -->
                      <section class="col col-12" id="category_selection">
                        <label class="label typo__label">{{
                          $label("event.categories", "Categories")
                        }}</label>
                        <multiselect
                          v-model="categoryValue"
                          tag-placeholder=""
                          :placeholder="
                            $label(
                              'event.instructor_categories_placeholder',
                              'Search or add category'
                            )
                          "
                          label="name"
                          track-by="id"
                          :options="categoryOptions"
                          class="v-multiselect v-form"
                          :multiple="true"
                          :taggable="false"
                          :show-labels="false"
                          @tag="addCategory"
                        >
                        </multiselect>

                        <p v-if="hasError('category_ids')" class="text-danger">
                          {{ getError("category_ids") }}
                        </p>
                      </section>
                      <!-- END Categories -->
                    </fieldset>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row"><div class="col-xs-12">&nbsp;</div></div>
          <hr />

          <div class="row">
            <div class="col-sm-12 text-center">
              <info-button
                :class="{ 'is-disabled': updating || !readWriteAccess }"
                id="save-instructor-button"
                icon="fa fa-lg fa-fw fa-save fa-check-square-o"
                :text="$label('common.save', 'Save')"
                @click.native="createOrUpdateInstructor"
              >
              </info-button>
              &nbsp;
              <warning-button
                v-show="
                  readWriteAccess &&
                    settingsAccess &&
                    status == 'active' &&
                    selectedInstructorId != null
                "
                :class="{
                  'is-disabled':
                    updating ||
                    selectedInstructorId == null ||
                    !readWriteAccess ||
                    !isDeletable
                }"
                id="deactivate-instructor-button"
                icon="fa fa-lg fa-fw fa-minus-square"
                :text="$label('common.deactivate', 'Dectivate')"
              >
              </warning-button>
              &nbsp;
              <warning-button
                v-show="
                  readWriteAccess &&
                    settingsAccess &&
                    status == 'inactive' &&
                    selectedInstructorId != null
                "
                :class="{
                  'is-disabled':
                    updating ||
                    selectedInstructorId == null ||
                    !readWriteAccess ||
                    !isDeletable
                }"
                id="activate-instructor-button"
                icon="fa fa-lg fa-fw fa-plus-square"
                :text="$label('common.activate', 'Activate')"
              >
              </warning-button>
              &nbsp;
              <danger-button
                :class="{
                  'is-disabled':
                    updating ||
                    selectedInstructorId == null ||
                    !readWriteAccess ||
                    !isDeletable
                }"
                id="delete-instructor-button"
                icon="fa fa-fw fa-lg fa-trash-o"
                :text="$label('common.delete', 'Delete')"
                @click.native="deleteInstructor"
              >
              </danger-button>
            </div>
          </div>

          <div class="row mb-4"><div class="col-xs-12">&nbsp;</div></div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import Api from "@/api.js";
import swal from "sweetalert";
import FormErrorsMixin from "@/mixins/FormErrors";
import Multiselect from "vue-multiselect";

import ViewLoader from "@/components/Common/ViewLoader";
import TextInput from "@/components/Common/Inputs/TextInput.vue";
import InfoButton from "@/components/Common/Buttons/InfoButton.vue";
import WarningButton from "@/components/Common/Buttons/WarningButton.vue";
import DangerButton from "@/components/Common/Buttons/DangerButton.vue";
import NavigationTabs from "@/components/Settings/Events/NavigationTabs.vue";
import Error404 from "@/components/Common/Error404";

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";

export default {
  name: "InstructorDetails.vue",

  mixins: [FormErrorsMixin],

  components: {
    ViewLoader,
    TextInput,
    InfoButton,
    WarningButton,
    DangerButton,
    NavigationTabs,
    Multiselect,
    quillEditor,
    Error404
  },

  data() {
    return {
      loading: false,
      updating: false,
      noDataExist: false,
      instructorHideCustomersMenu: false,
      instructorHideCustomersMenuInput: "",
      instructorImageRemovable: true,
      userMgmtAccess: true,
      readWriteAccess: true,
      settingsAccess: true,
      hasAccount: true,
      hasOperator: true,
      isDeletable: true,
      originalName: null,
      status: null,
      selectedInstructor: {
        //gender: null,
        //title: null,
        name: null,
        email: null,
        display_email: true,
        display_phone_number: false,
        website: null,
        facebook_link: null,
        youtube_link: null,
        twitter_link: null,
        note: null,
        description: null,
        phone_number: {
          prefix: null,
          number: null
        },
        category_ids: []
      },
      selectedInstructorId: null,
      failedRequest: false,
      validatedInputs: [
        "name",
        "email",
        "display_phone_number",
        "display_email",
        "website",
        "facebook_link",
        "youtube_link",
        "twitter_link",
        "note",
        "phone_number.prefix",
        "phone_number.number",
        "category_ids"
      ],
      allCategories: [
        //
      ],
      categoryValue: [
        //
      ],
      categoryOptions: [
        //
      ],
      editorOptions: {
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            ["blockquote"],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }],
            [{ size: ["small", false, "large", "huge"] }],
            [{ font: [] }],
            [{ color: [] }, { background: [] }],
            [{ align: [] }],
            ["link"]
          ]
        }
      },
      placeHolderUrl: require("@/assets/img/icon-user.png"),
      url: require("@/assets/img/icon-user.png"),
      newUrl: null,
      originalProfileImageUrl: null,
      profileImage: null
    };
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.getCategories();
      vm.selectedInstructorId = vm.$route.params.instructor_id;
      if (
        typeof vm.selectedInstructorId !== "undefined" &&
        vm.selectedInstructorId !== null
      ) {
        if (vm.$route.query.instructor_created) {
          swal("Success!", "The instructor was created.", "success").then(
            () => {
              window.history.pushState(
                {},
                document.title,
                window.location.pathname
              );
            }
          );
        }
        vm.getInstructor();
      } else {
        vm.newUrl = vm.placeHolderUrl;
      }
    });
  },

  beforeRouteUpdate(to, from, next) {
    this.getCategories();
    if (
      typeof this.selectedInstructorId !== "undefined" &&
      this.selectedInstructorId !== null
    ) {
      this.getInstructor();
    } else {
      this.newUrl = this.placeHolderUrl;
    }
    next();
  },

  mounted() {
    //
  },

  methods: {
    addCategory(category) {
      if (!this.categoryValue.some(c => c.id == category.id)) {
        this.categoryValue.push(category);
      }
    },

    getCategories(successCallback) {
      this.loading = true;
      this.allCategories = [];
      const endpoint = this.$partnerEndpoint("categories");

      Api()
        .get(endpoint, {
          params: { page: this.currentPage, search: this.searchFilter }
        })
        .then(response => {
          this.allCategories = response.data.data;
          this.failedRequest = false;
          for (let i = 0; i < this.allCategories.length; i++) {
            this.categoryOptions.push({
              name: this.allCategories[i].name,
              id: this.allCategories[i].id
            });
          }
          if (typeof successCallback == "function") {
            successCallback();
          }
        })
        .catch(() => {
          this.failedRequest = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    createOrUpdateInstructor() {
      if (this.selectedInstructorId == null) {
        this.createInstructor();
      } else {
        this.updateInstructor();
      }
    },

    createInstructor() {
      if (this.updating) {
        return;
      }

      if (this.categoryValue != null && this.categoryValue.length > 0) {
        for (let i = 0; i < this.categoryValue.length; i++) {
          this.selectedInstructor.category_ids.push(this.categoryValue[i].id);
        }
      }

      this.resetErrors();
      this.updating = true;
      const endpoint = this.$partnerEndpoint("instructors");

      Api()
        .post(endpoint, this.selectedInstructor)
        .then(response => {
          this.selectedInstructorId = response.data.data.id;
          if (
            this.originalProfileImageUrl != this.url &&
            this.url != null &&
            this.url != this.placeHolderUrl
          ) {
            this.updateInstructorProfileImage("create");
          } else {
            this.$router.push({
              name: "EventInstructorDetails",
              params: { instructor_id: this.selectedInstructorId },
              query: { instructor_created: true }
            });
          }
        })
        .catch(error => {
          this.storeErrors(error.response.data.errors);
          this.$scrollTo("#instructor-name", 500);
        })
        .finally(() => {
          this.updating = false;
        });
    },

    getInstructor() {
      this.resetErrors();
      this.loading = true;
      const endpoint = this.$partnerEndpoint(
        "instructors/" + this.selectedInstructorId
      );

      Api()
        .get(endpoint)
        .then(response => {
          this.selectedInstructor = response.data.data;
          this.originalName = this.selectedInstructor.name;
          this.status = this.selectedInstructor.status;
          for (var i = 0; i < this.selectedInstructor.categories.length; i++) {
            let cat = {
              id: this.selectedInstructor.categories[i].id,
              name: this.selectedInstructor.categories[i].name
            };
            this.addCategory(cat);
          }
          if (response.data.data.profile_image != null) {
            this.url = response.data.data.profile_image;
            this.originalProfileImageUrl = this.url;
            this.newUrl = this.url;
          } else {
            this.newUrl = this.placeHolderUrl;
          }
        })
        .catch(error => {
          if (error.response.status === 404) {
            this.noDataExist = true;
          }
          console.log(error.response);
        })
        .finally(() => {
          this.loading = false;
          if (
            this.selectedInstructor != null &&
            this.selectedInstructor.categories != null &&
            this.selectedInstructor.categories.length > 0
          ) {
            for (let i = 0; i < this.allCategories.length; i++) {
              for (
                let j = 0;
                j < this.selectedInstructor.categories.length;
                j++
              ) {
                if (
                  this.selectedInstructor.categories[j].id ==
                  this.allCategories[i].id
                ) {
                  this.addCategory({
                    name: this.allCategories[i].name,
                    id: this.allCategories[i].id
                  });
                }
              }
            }
          }
        });
    },

    updateInstructor() {
      if (this.loading || this.updating) {
        return;
      }

      this.resetErrors();
      this.updating = true;
      const endpoint = this.$partnerEndpoint(
        "instructors/" + this.selectedInstructorId
      );

      this.selectedInstructor.category_ids = [];
      if (this.categoryValue != null && this.categoryValue.length > 0) {
        for (let i = 0; i < this.categoryValue.length; i++) {
          this.selectedInstructor.category_ids.push(this.categoryValue[i].id);
        }
      }

      delete this.selectedInstructor.profile_image;
      delete this.selectedInstructor.categories;

      Api()
        .put(endpoint, this.selectedInstructor)
        .then(() => {
          if (
            this.originalProfileImageUrl != this.url &&
            this.url != null &&
            this.url != this.placeHolderUrl
          ) {
            this.updateInstructorProfileImage("update");
          } else {
            this.getInstructor(() => {
              //
            });
          }
          swal({
            title: "Success!",
            text: "The instructor was updated.",
            icon: "success"
          });
        })
        .catch(error => {
          this.storeErrors(error.response.data.errors);
          this.$scrollTo("#instructor-name", 500);
        })
        .finally(() => {
          this.updating = false;
        });
    },

    deleteInstructor() {
      if (this.loading || this.updating) {
        return;
      }

      swal({
        title: "Are you sure?",
        text: "The instructor will be deleted",
        icon: "warning",
        dangerMode: true,
        buttons: {
          cancel: {
            visible: true,
            text: "Cancel",
            closeModal: true
          },
          confirm: {
            visible: true,
            text: "Yes, delete it!",
            closeModal: true
          }
        }
      }).then(isConfirm => {
        if (isConfirm) {
          const endpoint = this.$partnerEndpoint(
            "instructors/" + this.selectedInstructorId
          );

          Api()
            .delete(endpoint)
            .then(() => {
              this.$router.push({
                name: "EventInstructors",
                query: { instructor_deleted: true }
              });
            })
            .catch(error => {
              console.log(error.response);
              if (error.response.status === 403) {
                swal({
                  title: "Missing permission",
                  text: "You are not allowed to delete instructors.",
                  icon: "error"
                  //dangerMode: true,
                });
              }
            });
        } else {
          //
        }
      });
    },

    updateInstructorProfileImage(origin) {
      this.resetErrors();
      this.updating = true;
      const endpoint = this.$partnerEndpoint(
        "instructors/" + this.selectedInstructorId + "/profile-image"
      );

      let formData = new FormData();
      if (this.profileImage != null) {
        formData.append("profile_image", this.profileImage);
        formData.append("_method", "put");
      } else {
        return;
      }

      Api()
        .post(endpoint, formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(response => {
          console.log(response);

          if (origin == "create") {
            this.$router.push({
              name: "EventInstructorDetails",
              params: { instructor_id: this.selectedInstructorId },
              query: { instructor_created: true }
            });
          }
          if (origin == "update") {
            swal({
              title: "Success!",
              text: "The instructor was updated.",
              icon: "success"
            });
          }
        })
        .catch(error => {
          this.storeErrors(error.response.data.errors);
          this.$scrollTo("#instructor-name", 500);
        })
        .finally(() => {
          this.updating = false;
        });
    },

    deleteInstructorProfileImage() {
      swal({
        title: "Are you sure?",
        text: "The profile image will be deleted",
        icon: "warning",
        dangerMode: true,
        buttons: {
          cancel: {
            visible: true,
            text: "Cancel",
            closeModal: true
          },
          confirm: {
            visible: true,
            text: "Yes, delete it!",
            closeModal: true
          }
        }
      }).then(isConfirm => {
        if (isConfirm) {
          /*const endpoint = this.$partnerEndpoint('instructors/' + this.selectedInstructorId  + '/profile-image');

                        Api().delete(endpoint)
                            .then(() => {
                                this.url = this.placeHolderUrl;
                                this.newUrl = this.placeHolderUrl;
                                this.profileImage = null;
                                swal({
                                    title: 'Success!',
                                    text: 'The profile image was deleted',
                                    icon: 'success',
                                });
                                
                            })
                            .catch((error) => {
                                console.log(error.response);
                                if (error.response.status === 403) {
                                    swal({
                                        title: 'Missing permission',
                                        text: 'You are not allowed to delete the profile image.',
                                        icon: 'error',
                                        //dangerMode: true,
                                    });
                                }
                            });*/
        } else {
          //
        }
      });
    },

    onFileChange(e) {
      const file = e.target.files[0];
      var reader = new FileReader();
      reader.readAsDataURL(file);
      this.newUrl = URL.createObjectURL(file);
    },

    onUpdateInstructorProfileImage() {
      this.url = this.newUrl;
      this.profileImage = this.$refs.profileImage.files[0];
    },

    onDeleteInstructorProfileImage() {
      this.deleteInstructorProfileImage();
    }
  },

  computed: {
    editor() {
      return this.$refs.instructorDescriptionEditor.quill;
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.mt-6 {
  margin-top: 1.6em;
}
.mt-8 {
  margin-top: 2em;
}
.mb-4 {
  margin-bottom: 1.2rem;
}
#instructorImgImage {
  max-width: 100%;
  max-height: 400px;
}
</style>
